
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(155|292|643|893)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
